import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-10 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }),
          _createElementVNode("div", {
            "aria-modal": "true",
            class: _normalizeClass(["inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full", _ctx.maxWidth]),
            role: "dialog"
          }, [
            _renderSlot(_ctx.$slots, "header"),
            _renderSlot(_ctx.$slots, "body", {}, () => [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " Custom modal content goes here. ", -1))
            ]),
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              _createElementVNode("button", {
                class: "mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " Close ")
            ])
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}